export default {"src":"/_next/static/media/AMCR.3230f206.svg","height":18,"width":18};